// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

//登录
const Login = () => import("@/views/login")

//首页
const Index = () => import("@/views/index")
/**
 * 系统模块
 */
// 系统设置
const Setting = () => import("@/views/setting/Setting")
/**
 * 内容模块
 */
// 章节列表
const ArticleList = () => import("@/views/article/ArticleList")
// 新增章节
const AddArticle = () => import("@/views/article/AddArticle")
// 编辑章节
const EditArticle = () => import("@/views/article/EditArticle")

/**
 * 兑换码模块
 */
//兑换码列表
const CdkList = () => import("@/views/cdk/CdkList")
//兑换码记录
const CdkRecord = () => import("@/views/cdk/CdkRecord")


/**
 * 订单模块
 */
//订单流水
const OrderList = () => import("@/views/order/OrderList")

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: Login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: Login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: Index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/setting/Setting',
            name: '系统设置',
            component: Setting,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/article/ArticleList',
            name: '章节列表',
            component: ArticleList,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/article/AddArticle',
            name: '新增章节',
            component: AddArticle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/article/EditArticle/:id',
            name: '编辑章节',
            component: EditArticle,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cdk/CdkList',
            name: '兑换码列表',
            component: CdkList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cdk/CdkRecord',
            name: '兑换码记录',
            component: CdkRecord,
            meta: {
                requireAuth: true
            }
        },{
            path: '/order/OrderList',
            name: '订单流水',
            component: OrderList,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js